import axios from 'axios';
import moment from 'moment-timezone';

const API_URL = process.env.REACT_APP_API_URL;

export const getTasks = async () => {
  try {
    const token = localStorage.getItem('token');

    const eventsResponse = await axios.get(`${API_URL}/events`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const sharedCalendarResponse = await axios.get(`${API_URL}/events/shared-calendar`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const events = eventsResponse.data.map((event) => ({
      ...event,
      event_type: event.event_type ?? null,   // <-- ADD THIS
      start: moment.utc(event.start).local().format(),
      end: moment.utc(event.end).local().format(),
      shared: false,
    }));

    const sharedEvents = sharedCalendarResponse.data.map((shared) => ({
      ...shared,
      event_type: shared.event_type ?? null,  // <-- ADD THIS
      start: moment.utc(shared.start).local().format(),
      end: moment.utc(shared.end).local().format(),
      shared: shared.is_shared,
    }));

    return [...events, ...sharedEvents];
  } catch (error) {
    console.error('Error fetching tasks and shared events:', error);
    throw error;
  }
};



export const createTask = async (taskDetails) => {
  try {
    const token = localStorage.getItem('token');
    const taskDetailsWithUTC = {
      ...taskDetails,
      event_type: taskDetails.event_type ?? null,  // <-- ADD THIS
      start: moment(taskDetails.start).utc().format(),
      end: moment(taskDetails.end).utc().format(),
    };

    const response = await axios.post(`${API_URL}/events`, taskDetailsWithUTC, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data;
  } catch (error) {
    console.error('Error creating task:', error);
    throw error;
  }
};



export const updateTask = async (taskId, updatedTaskDetails) => {
  try {
    const token = localStorage.getItem('token');

    const { start, end, ...restDetails } = updatedTaskDetails;

    const taskUpdateData = {
      ...restDetails,
      event_type: updatedTaskDetails.event_type ?? null,   // <-- ADD THIS
      start: moment.tz(start, 'Asia/Bangkok').utc().format(),
      end: moment.tz(end, 'Asia/Bangkok').utc().format(),
    };

    const response = await axios.put(`${API_URL}/events/${taskId}`, taskUpdateData, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error;
  }
};


export const deleteTask = async (taskId, params) => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No token found');
  }

  // Include deleteGroup flag as a query parameter in the DELETE request
  const response = await axios.delete(`${API_URL}/events/${taskId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: params, // Add the params (deleteGroup flag) here
  });

  return response.data;
};
